var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"scale"},[_c('input-select',{staticClass:"scale_select",attrs:{"options":_vm.options,"value":_vm.value},on:{"select":_vm.setValue}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }